//import { Notification } from "element-ui";
//import { api } from "../../gateways/unilabApi";

export default {
  getColoriCard() {
    var list = [];
    list.push("#f2f2f2"); // sfondo #013A6B
    list.push("#013A6B"); // barra con titolo #e0f2fc
    list.push("#000000"); // testo
    list.push("#FFFFFF"); // titolo
    list.push("#F0F0F0"); // sfondo di eventuale tab
    list.push("#000000"); // testo di eventuale tab
    list.push("#9299a3"); // bordo
    return list;
  },

  getColoriSidebar() {
    var list = [];
    list.push("#003A6C")//("#535353"); // sfondo dddddd
    list.push("#FFFFFF"); // testo
    list.push("#e0f2fc"); // titoli
    list.push("#d41316"); // bottone logout
    list.push("#e0f2fc"); // simboli
    list.push("#d41316"); // bordo bottone
    list.push("#FFFFFF"); // testo bottone
    return list;
  },

  getColoriHeader() {
    var list = [];
    list.push("#003A6C");//("#535353"); // sfondo
    list.push("#FFFFFF"); // testo
    return list;
  },

  getColoriFooter() {
    var list = [];
    list.push("#003A6C");//("#013a6b"); // sfondo
    list.push("#FFFFFF"); // testo
    list.push("#0077be"); // bottoni
    list.push("#FFFFFF"); // testo bottoni
    list.push("#0077be"); // bordo bottoni
    list.push("#FFFFFF"); // bordo
    return list;
  },

  getColoriBody() {
    var list = [];
    list.push("#f2f2f2"); // sfondo
    return list;
  }
};
